import React from 'react';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import type { IconProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Icon';

import Card from '../../../../../components/Card';

import './style.scss';

export interface TaxonomyThemeCardParentProps {
  url: string;
  title: string;
  icon?: IconProps['name'];
  iconFlair?: IconProps['flair'];
  className?: string;
}

const TaxonomyThemeCardParent: React.FC<TaxonomyThemeCardParentProps> = (props) => {
  const {
    url,
    title,
    icon,
    iconFlair,
    className,
  } = props;

  const classes = c('TaxonomyThemeCard--Parent', className);

  return (
    <Card className={classes}>
      <Card.Link link={url}>
        <Card.Title title={title} className="asH2" />
      </Card.Link>

      <div className="Card__icons">
        {icon && (
          <Icon
            className="Card__illustration"
            name={icon}
            flair={iconFlair}
          />
        )}

        <div className="Card__icon-wrapper">
          <Icon name="arrow_forward" flair="outlined" />
        </div>
      </div>
    </Card>
  );
};

export default TaxonomyThemeCardParent;
